/**
 * 费用中心
 */
export default [
  {
    path: '/fee',
    name: 'fee',
    component: () => import('@/views/user/fee/Fee'),
    meta: { title: '费用中心' }
  },
  {
    path: '/fee/orderAnnal',
    name: 'annal',
    component: () => import('@/views/user/fee/OrderAnnal'),
    meta: {
      title: '订单记录'
    }
  }
]
